import React from "react";
import { useAuth } from "../../Context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

const Card = ({ data }) => {
  const { editLocalData, editLocalNumberData, deleteLocalData } = useAuth();
  const currentPage = useSelector((state) => state.activePage);

  const dispatch = useDispatch();

  // function handleEdit(e, id) {
  //   editLocalData(e, id);
  // }
  function handleEdit(e, id) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (e.target.name.includes("amount")) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      } else {
        dispatch(
          getErrorMessage(
            `Felaktig inmatning i ${currentPage}, var god skriv in siffror!`
          )
        );
        const delayEditData = setTimeout(() => {
          dispatch(getErrorMessage(""));
        }, 5000);
        return () => clearTimeout(delayEditData);
      }
    } else {
      editLocalData(e, id);
    }
  }

  function handleDelete(id) {
    deleteLocalData(id);
  }

  return (
    <div className="container-input-mobile">
        <div className="container-inner-mobile-direction-row">
          <label>Namn</label>
          <input
            className="input-mobile "
            type="text"
            name="category"
            defaultValue={data.object.category}
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
          />
        
          <label>Summa</label>
          <input
            className="input-mobile "
            type="text"
            name="amount"
            defaultValue={data.object.amount === "0" ? "" : data.object.amount}
            autoComplete="off"
            onChange={(e) => handleEdit(e, data.id)}
          />
        </div>
      <button className="button-delete" onClick={() => handleDelete(data.id)}>
        Ta bort rad
      </button>
    </div>
  );
};
export default Card;
